import CMSContent from './CMSContent.jsx';

export {CMSContent}



// WEBPACK FOOTER //
// ./components/cms/index.js